import axios from "axios";
import { ensureAssistantIdentity } from "./clientIdentity";
import { buildAssistantUrl } from "./assistantApi";

export const initiateSession = async (userId) => {
    try {
        const auth_token = localStorage.getItem("token");
        if (!auth_token) {
            throw new Error("auth token missing");
        }

        const { clientId, conversationId } = ensureAssistantIdentity({
            userId,
            resetConversation: true,
            notify: true,
        });
        const initiationResponse = await axios.post(
            buildAssistantUrl("initiatesession/"),
            { clientId, conversationId },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: auth_token,
                },
                withCredentials: true,
            },
        );
        localStorage.setItem("sessionInitialized", "true");
        localStorage.removeItem("messages");
        return { clientId, conversationId, success: true, status: initiationResponse?.status };
    } catch (error) {
        const detail =
            error?.response?.data ||
            error?.message ||
            "Unknown error during initiate session";
        console.error("[AI Assistant] initiateSession failed", detail);
        return { success: false, error: detail };
    }
};
